import type { FsId } from '@fullstory/recording-api';
import type { FsDocument } from './fsdocument';
import { FsNode } from './fsnode';

/** The vDOM representation of a <noscript> element. */
export class FsNoScriptElement extends FsNode {
  constructor(ownerDoc: FsDocument, fsid?: FsId) {
    super(ownerDoc, 'noscript', undefined, fsid);
  }

  protected createNode(doc: Document): Node {
    return doc.createElement('noscript');
  }

  /** @override */
  protected flushAttr(_dom: Node, _name: string, _value: string | null): void {
    // We deliberately don't call the superclass implementation to disallow all
    // attributes on these elements. That's just a bit of paranoia, since we
    // translate <script> elements into <noscript> elements if they appear in
    // the recording.
  }
}
